export const config = {
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
}
